import { FilterResult } from 'src/app/shared/components/odata-filter/models/filter-result';
import { Image } from 'src/app/people/models/image';
import { PersonScenarioReportModel } from '../../../reports/person-scenario-report/person-scenario-report.model';
import { CredentialApplicationDefinitionType } from '../../models/credential/CredentialApplicationDefinitionType';

export class PersonCredentialApplicationReportModel {
  public id: string;
  public personId: string;
  public personCredentialId: string;
  public imageId: string;
  public image: Image;
  public email: string;
  public firstName: string;
  public middleName: string;
  public lastName: string;
  public fullName: string;
  public suffix: string;
  public externalSystemId: string;
  public credentialApplicationDefinitionId: string;
  public credentialApplicationType: string;
  public credentialApplicationNumber: string;
  public credentialApplicationStartDate: Date;
  public credentialApplicationEndDate?: Date;
  public credentialApplicationUpdatedBy: string;
  public credentialApplicationUpdatedOn: Date;
  public credentialApplicationCreatedBy: string;
  public credentialApplicationCreatedOn: Date;
  public credentialDefinitionId: string;
  public credentialName: string;
  public scenarios: PersonScenarioReportModel[] = [];
  public status: string;

  static parse(data: any): PersonCredentialApplicationReportModel {
    if (!data) return null;
    let model = new PersonCredentialApplicationReportModel();
    Object.assign(model, data);
    if (model.imageId) {
      model.image = new Image(model.imageId);
    }

    if (data.credentialApplicationType == CredentialApplicationDefinitionType.Initial) {
      model.credentialApplicationType = 'New Credential';
    }
    return model;
  }
}

export class PersonCredentialApplicationReportFilterResult implements FilterResult {
  public count: number;
  public values: any[] = [];
  public nextLink: string;

  public parse(response: any) {
    let result = new PersonCredentialApplicationReportFilterResult();
    result.count = response['@odata.count'];
    result.values = response.value.map((report) =>
      PersonCredentialApplicationReportModel.parse(report)
    );
    result.nextLink = response['@odata.nextLink'];
    return result;
  }
}
